import { Classes, Dialog, Intent, Button } from "./externals";
import * as React from "react";
export class ButtonWithDialog extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleAcceptDialog = () => {
            this.props.onAccept(this.state.content);
            this.closeDialog();
        };
        this.openDialog = () => {
            this.props.onOpen && this.props.onOpen();
            this.setState({
                isDialogOpen: true,
            });
        };
        this.closeDialog = () => {
            this.props.onClose && this.props.onClose();
            this.setState({
                isDialogOpen: false,
            });
            if (this.props.defaultContent) {
                this.setState({
                    content: this.props.defaultContent,
                });
            }
        };
        this.updateContent = (content) => {
            this.setState({ content });
        };
        this.state = {
            isDialogOpen: false,
            content: props.defaultContent,
        };
    }
    componentDidUpdate(prevProps) {
        const equals = (a, b) => JSON.stringify(a) === JSON.stringify(b);
        if (!equals(this.props.defaultContent, prevProps.defaultContent) &&
            this.props.defaultContent) {
            this.setState({ content: this.props.defaultContent });
        }
    }
    render() {
        const { icon, className, text = "", hideButtons, intent, minimal, loading, disabled, usePortal, style, enforceFocus, } = this.props;
        const { isDialogOpen, content } = this.state;
        return (React.createElement(React.Fragment, null,
            React.createElement(Button, { icon: icon, className: className, text: text, loading: loading, intent: intent, minimal: minimal, disabled: disabled, onClick: this.openDialog, style: this.props.buttonStyle, "data-testid": "buttonWithDialog_" + text }),
            React.createElement(Dialog, { className: "scheduleDialog", icon: icon, title: text, isOpen: isDialogOpen, style: style, usePortal: usePortal ? false : process.env.NODE_ENV !== "test", onClose: this.closeDialog, enforceFocus: enforceFocus },
                React.createElement("div", { className: Classes.DIALOG_BODY }, this.props.form({ onUpdate: this.updateContent, content })),
                hideButtons ? (React.createElement("div", { className: Classes.DIALOG_FOOTER },
                    React.createElement("div", { className: Classes.DIALOG_FOOTER_ACTIONS },
                        React.createElement(Button, { onClick: this.closeDialog, "data-testid": "closeFooterButton" }, "Close")))) : (React.createElement("div", { className: Classes.DIALOG_FOOTER },
                    React.createElement("div", { className: Classes.DIALOG_FOOTER_ACTIONS },
                        React.createElement(Button, { onClick: this.closeDialog }, "Cancel"),
                        React.createElement(Button, { "data-testid": "acceptFooterButton", intent: Intent.PRIMARY, onClick: () => this.handleAcceptDialog() }, "Accept")))))));
    }
}
//# sourceMappingURL=ButtonWithDialog.js.map